var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDropZoneBase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1828 13.068C12.1266 13.0443 12.0649 13.0312 12 13.0312C11.9373 13.0312 11.8775 13.0434 11.8229 13.0657C11.7662 13.0887 11.7131 13.1232 11.6671 13.1692L10.081 14.7567C9.89735 14.9406 9.89748 15.2385 10.0813 15.4222L10.1257 15.4613C10.3104 15.6048 10.5773 15.5916 10.7469 15.4219L11.5294 14.6386V17.4706C11.5294 17.7305 11.7401 17.9412 12 17.9412C12.2599 17.9412 12.4706 17.7305 12.4706 17.4706V14.6386L13.2532 15.4219C13.4368 15.6058 13.7348 15.6059 13.9187 15.4222C14.1025 15.2385 14.1027 14.9406 13.919 14.7567L12.3344 13.1706C12.3297 13.1659 12.325 13.1613 12.3201 13.1568C12.2788 13.1184 12.2322 13.0888 12.1828 13.068Z",
    fill: "#00AEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6287 10.1502C8.6287 8.36865 10.1074 7 12 7C13.8947 7 15.3856 8.37046 15.3856 10.1502C15.3856 10.8047 15.1829 11.329 14.7637 11.8352L14.7139 11.8927L14.8322 11.9815C15.5564 12.5514 15.9636 13.3555 15.9977 14.3023L16 14.4326C16 15.4164 15.5586 16.3295 14.8086 16.9997L14.1931 16.2874C14.7131 15.818 15.0235 15.2038 15.056 14.5472L15.0588 14.4326C15.0588 13.5289 14.6124 12.83 13.7522 12.4127C13.4513 12.2667 13.3944 11.8622 13.6434 11.6389C14.2152 11.1262 14.4444 10.7184 14.4444 10.1502C14.4444 8.90878 13.3918 7.94118 12 7.94118C10.6116 7.94118 9.56988 8.90541 9.56988 10.1502C9.56988 10.7183 9.80078 11.1404 10.3566 11.639C10.6056 11.8623 10.5487 12.2667 10.2478 12.4127C9.3877 12.83 8.94117 13.5289 8.94117 14.4326C8.94117 15.1318 9.2563 15.7902 9.80694 16.2874L9.19144 16.9996C8.44081 16.3289 8 15.4158 8 14.4326C8 13.3836 8.44888 12.5002 9.27341 11.9017L9.288 11.8913L9.2447 11.8399C8.8591 11.3679 8.65668 10.8717 8.63141 10.2788L8.6287 10.1502ZM12 8.88399C11.2201 8.88399 10.5882 9.51645 10.5882 10.2962C10.5882 11.0759 11.2201 11.7084 12 11.7084C12.7799 11.7084 13.4118 11.0759 13.4118 10.2962C13.4118 9.51645 12.7799 8.88399 12 8.88399ZM12 9.82517C12.2599 9.82517 12.4706 10.0361 12.4706 10.2962C12.4706 10.5563 12.2599 10.7672 12 10.7672C11.7401 10.7672 11.5294 10.5563 11.5294 10.2962C11.5294 10.0361 11.7401 9.82517 12 9.82517Z",
    fill: "#0973F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 4,
    cy: 3,
    r: 1,
    fill: "#00AEEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 8,
    cy: 3,
    r: 1,
    fill: "#00AEEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 12,
    cy: 3,
    r: 1,
    fill: "#00AEEE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 16,
    cy: 3,
    r: 1,
    fill: "#00AEEE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 20,
    cy: 3,
    r: 1,
    fill: "#00AEEE"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 4,
    cy: 21,
    r: 1,
    fill: "#00AEEE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 8,
    cy: 21,
    r: 1,
    fill: "#00AEEE"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 12,
    cy: 21,
    r: 1,
    fill: "#00AEEE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 16,
    cy: 21,
    r: 1,
    fill: "#00AEEE"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 20,
    cy: 21,
    r: 1,
    fill: "#00AEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDropZoneBase);
export default __webpack_public_path__ + "static/media/fileDropZoneBase.b499bb77.svg";
export { ForwardRef as ReactComponent };